var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85372 9.14653C9.90018 9.19298 9.93703 9.24813 9.96217 9.30883C9.98731 9.36953 10.0003 9.43458 10.0003 9.50028C10.0003 9.56598 9.98731 9.63103 9.96217 9.69173C9.93703 9.75242 9.90018 9.80757 9.85372 9.85403C9.80727 9.90048 9.75212 9.93733 9.69142 9.96247C9.63072 9.98762 9.56567 10.0006 9.49997 10.0006C9.43428 10.0006 9.36922 9.98762 9.30853 9.96247C9.24783 9.93733 9.19268 9.90048 9.14622 9.85403L4.99997 5.70715L0.853723 9.85403C0.759902 9.94785 0.632655 10.0006 0.499973 10.0006C0.367291 10.0006 0.240043 9.94785 0.146223 9.85403C0.0524025 9.76021 -0.000305173 9.63296 -0.000305176 9.50028C-0.000305178 9.3676 0.0524025 9.24035 0.146223 9.14653L4.2931 5.00028L0.146223 0.854028C0.0524025 0.760208 -0.000305176 0.63296 -0.000305176 0.500278C-0.000305176 0.367596 0.0524025 0.240348 0.146223 0.146528C0.240043 0.0527077 0.367291 0 0.499973 0C0.632655 0 0.759902 0.0527077 0.853723 0.146528L4.99997 4.2934L9.14622 0.146528C9.24004 0.0527077 9.36729 -2.61548e-09 9.49997 0C9.63266 2.61548e-09 9.7599 0.0527077 9.85372 0.146528C9.94754 0.240348 10.0003 0.367596 10.0003 0.500278C10.0003 0.63296 9.94754 0.760208 9.85372 0.854028L5.70685 5.00028L9.85372 9.14653Z",
    fill: "#748181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ba20292bc76e81048d6cce03c9c99753.svg";
export { ForwardRef as ReactComponent };